import React, { useEffect, useState } from 'react';

export const SmallSmsIcon = ({ width, height }) => {

  const [color, setColor] = useState('');
  const DOMstyle = document.documentElement.style;

  // On Init
  useEffect(() => {
    const color = DOMstyle.getPropertyValue("--custom-primary-background-color");
    setColor(color);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <svg width={width} height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M26.54,27.13l1-4.81-0.5-1a7.83,7.83,0,0,1-.53-2.83c0-5,4.7-9,10.5-9s10.5,4,10.5,9-4.7,9-10.5,9a11.89,11.89,0,0,1-4.78-1l-0.74-.35-4.95,1" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/><circle cx="11" cy="37.85" r="2"/><rect x="0.5" y="9.5" width="21" height="33" rx="2" ry="2" fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="2"/><line x1="0.5" y1="33.5" x2="21.5" y2="33.5" fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="2"/><line x1="0.5" y1="14.5" x2="21.5" y2="14.5" fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="2"/><rect width="48" height="48" fill="none"/></svg>
    </>
  );
}